// src/components/layout/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Lock } from 'lucide-react';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-lg bg-white/80 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 min-w-0">
          <div className="flex items-center min-w-0 flex-1">
            <Link to="/" className="flex items-center flex-shrink-0">
              <span className="flex items-center font-bold text-xl sm:text-2xl text-gray-900 whitespace-nowrap">
                <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">Price</span>Patent
              </span>
            </Link>
            <nav className="hidden md:ml-4 lg:ml-10 md:flex md:space-x-4 lg:space-x-8 flex-shrink-0">
              <Link className="text-gray-500 hover:text-gray-900 px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap" to="/">Home</Link>
              <Link className="text-gray-500 hover:text-gray-900 px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap" to="/solutions/cross-licensing">Solutions</Link>
              <Link className="text-gray-500 hover:text-gray-900 px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap" to="/products">Products</Link>
              <Link
                to="/demo"
                className="flex items-center px-2 lg:px-3 py-2 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors duration-300 whitespace-nowrap"
              >
                <span>Demo</span>
                <span className="ml-2 px-2 py-0.5 text-xs font-semibold text-white bg-blue-600 rounded-full">Try free</span>
                <Lock className="ml-1 h-3 w-3 text-gray-400 flex-shrink-0" />
              </Link>
              <Link className="text-gray-500 hover:text-gray-900 px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap" to="/about">About</Link>
              <Link className="text-gray-500 hover:text-gray-900 px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap" to="/sample-report">Sample Report</Link>
            </nav>
          </div>

          <div className="flex items-center flex-shrink-0 ml-2">
            <Link to="/contact" className="hidden md:block px-3 lg:px-4 py-2 text-sm font-medium rounded-lg bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-700 hover:via-indigo-700 hover:to-purple-700 text-white transition-all duration-300 whitespace-nowrap">
              Contact
            </Link>
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-900 transition-colors duration-300"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-gray-200">
          <div className="px-4 pt-4 pb-5 space-y-2">
            <Link className="block px-5 py-4 text-lg font-medium text-gray-900 hover:bg-blue-50 rounded-xl transition-colors duration-300" to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link className="block px-5 py-4 text-lg font-medium text-gray-900 hover:bg-blue-50 rounded-xl transition-colors duration-300" to="/solutions/cross-licensing" onClick={() => setMobileMenuOpen(false)}>Solutions</Link>
            <Link className="block px-5 py-4 text-lg font-medium text-gray-900 hover:bg-blue-50 rounded-xl transition-colors duration-300" to="/products" onClick={() => setMobileMenuOpen(false)}>Products</Link>
            <Link
              to="/demo"
              className={`flex items-center px-5 py-4 text-lg ${location.pathname === '/demo' ? 'font-semibold text-gray-900' : 'font-medium text-gray-900'} hover:bg-blue-50 rounded-xl transition-colors duration-300`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <span>Demo</span>
              <span className="ml-2 px-2 py-0.5 text-xs font-semibold text-white bg-blue-600 rounded-full">Try free</span>
              <Lock className="ml-1 h-3 w-3 text-gray-400" />
            </Link>
            <Link
              to="/about"
              className={`block px-5 py-4 text-lg ${location.pathname === '/about' ? 'font-semibold' : 'font-medium'} text-gray-900 hover:bg-blue-50 rounded-xl transition-colors duration-300`}
              onClick={() => setMobileMenuOpen(false)}
            >About</Link>
            <Link
              to="/sample-report"
              className={`block px-5 py-4 text-lg ${location.pathname === '/sample-report' ? 'font-semibold' : 'font-medium'} text-gray-900 hover:bg-blue-50 rounded-xl transition-colors duration-300`}
              onClick={() => setMobileMenuOpen(false)}
            >Sample Report</Link>
            <Link
              to="/contact"
              className={`block px-5 py-4 text-lg ${location.pathname === '/contact' ? 'font-semibold' : 'font-medium'} bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-700 hover:via-indigo-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300`}
              onClick={() => setMobileMenuOpen(false)}
            >Contact</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;